import React from "react";
type PropsSpacer = {
  flex?: boolean;
  width?: string | number;
  height?: string | number;
  className?:string
};
const Spacer = (props: PropsSpacer) => {
  return (
    <div
    className={props.className}
      style={
        props.flex ? { flex: 1 } : { width: props.width, height: props.height }
      }
    ></div>
  );
};

export default Spacer;
